import { SensorType } from "@shared/enums";
import { CheckboxFilterElement } from "./checkboxFilter.element";

export class AbFilterSensorFormatElement extends CheckboxFilterElement<SensorType> {
  constructor() {
    super({ label: "Formato sensore", eventName: "sensor-format-filter-change", optionLabel: (value) => value });
  }
}

export const defineAbFilterSensorFormatElement = () => {
  if (!customElements.get("ab-filter-sensor-format")) customElements.define("ab-filter-sensor-format", AbFilterSensorFormatElement);
};
